import React from 'react';
import PropTypes from 'prop-types';
import TabLayout from '../../../../components/TabLayout';
import { Dialog, Stack, Typography, IconButton, Tabs, Tab, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import Transition from '../../../../components/Transition';
import { useState } from 'react';
import AddEditTrader from './AddEditTrader';
import AddEditContact from './AddEditContact';
import * as yup from 'yup';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import appapi from '../../../../api/apiClient';
import { useRef } from 'react';
import { matchIsValidTel } from 'mui-tel-input';

const validationSchema = yup.object({
  contact: yup.array().of(
    yup.object().shape({
      contactName: yup.string('Name').min(3, 'Name should be atleast 3 characters').max(50, 'Maximum Character Limit 50').required(' '),
      contactEmail: yup
        .string('Email ID')
        .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Email is Invalid')
        .trim()
        .nullable()
        .required(' '),

      // contactNumber: yup
      //   .string('Phone Number')
      //   .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, 'Mobile Number is Invalid')
      //   .required('Phone Number is required')
      //   .min(7, 'Phone Number should be atleast 7 character')
      //   .max(15, 'Maximum Character Limit 15'),
      phone: yup
        .string('Phone Number').required().test('is-valid-number', 'Mobile Number is Invalid', value => {
          if (value) {
            return matchIsValidTel(value)
          }

          return false;
        }),
      contactDesignation: yup.string('Contact Designation').min(3, 'Designation should be atleast 3 characters').max(50, 'Maximum Character Limit 50').required(' '),
    }),
  ),
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function AddEditDialog({ modelOpen, onModelHandleClose }) {
  const [tabIndexValue, setValue] = React.useState(0);
  const [openAddTrader, setOpenAddTrader] = useState(false);
  const [trader, setTrader] = useState(null);
  const dispatch = useDispatch();
  const formRef = useRef();
  const { user, userId } = useSelector((state) => state.auth);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddTraderContact = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      contacts: values.contact.map((res) => {
        return {
          ...res,
          operation: 'create',
        };
      }),
      adminId: userId,
    };
    const response = await appapi.post(`/trader/contacts/${trader?._id}`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true)
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // TransitionComponent={Transition}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack style={{ backgroundColor: '#FFFFFF' }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="sticky top-[0] !bg-[#ffffff] z-[9] h-[56px]"
          style={{ paddingLeft: '24px', paddingRight: '24px', borderBottomWidth: 1, borderBottomColor: '#0000000D' }}
        >
          <Tabs
            indicatorColor="primary"
            value={tabIndexValue}
            onChange={handleChange}
          >
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="ADD TRADER"
              {...a11yProps(0)}
            />
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="ADD CONTACT"
              {...a11yProps(1)}
              disabled={!Boolean(trader)}
            />
          </Tabs>
          <div>
            <IconButton onClick={() => onModelHandleClose(true)}>
              <ClearIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '22px', height: '22px' }} />
            </IconButton>
          </div>
        </Stack>
        <TabPanel
          className="!p-[0px]"
          value={tabIndexValue}
          index={0}
        >
          {tabIndexValue === 0 ? (
            <AddEditTrader
              trader={trader}
              onSuccess={(val) => {
                setTrader(val);
                setValue(1);
              }}
              handleClose={() => onModelHandleClose(false)}
            />
          ) : null}
        </TabPanel>


        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          autoComplete="off"
          initialValues={{
            contact: [
              {
                contactId: '',
                contactName: '',
                contactDesignation: '',
                contactEmail: '',
                contactNumber: '',
                phone: '',
                phoneCode: '',
              },
            ],
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleAddTraderContact(values);
          }}
        >
          {() => (
            <TabPanel
              value={tabIndexValue}
              index={1}
            >
              {tabIndexValue === 1 ? <AddEditContact
                traderId={trader?._id}
                onClose={(evt) => {
                  if (evt) {
                    onModelHandleClose(true);
                  }
                }}
                handleClose={() => onModelHandleClose(true)}
              /> : null}  </TabPanel>)}
        </Formik>

      </Stack>
      {/* {openAddTrader ? (
        <AddEditCompany
          onModelHandleClose={(event) => {
            if (event) {
              getCompanyDetails();
            }
            setOpenAddCompany(false);
          }}
          modelOpen={openAddCompany}
          companyDetails={companyDetails}
        />
      ) : null} */}
    </Dialog>
  );
}
